import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ImageWithBasePath from '../../../core/img/imagewithbasepath';
import { api_get } from '../../../helpers/index';
import Swal from 'sweetalert2';
import { all_routes } from "../../../Router/all_routes";

const PrizeDetail = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const prize_id = searchParams.get("prize_id");

    const navigate = useNavigate();

    const route = all_routes;

    const [prizeDetails, setPrizeDetails] = useState(null);

    useEffect(() => {
        // Fetch prize details
        const fetchPrizeDetails = async () => {
            try {
                const response = await api_get(`spinwheel/prize/get/${prize_id}`);
                if (response.status === 1) {
                    setPrizeDetails(response.data);
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "Failed to load prize details.",
                    });
                }
            } catch (error) {
                console.error("Error fetching prize details:", error);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "An error occurred while fetching prize details.",
                });
            }
        };

        if (prize_id) {
            fetchPrizeDetails();
        }
    }, [prize_id]);

    if (!prizeDetails) {
        return <div>Loading...</div>;
    }

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="page-header">
                    <div className="page-title">
                        <h4>Prize Details</h4>
                        <h6>Full details of the prize</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-8 col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="prizedetails">
                                    <ul className="product-bar">
                                        <li>
                                            <h4>Prize Name</h4>
                                            <h6>{prizeDetails.name}</h6>
                                        </li>
                                        <li>
                                            <h4>Description</h4>
                                            <h6>{prizeDetails.description}</h6>
                                        </li>
                                        <li>
                                            <h4>Prize Type</h4>
                                            <h6 style={{ textTransform: 'capitalize' }}>
                                                {prizeDetails.prize_type || 'gift'}
                                            </h6>
                                        </li>
                                        {prizeDetails.prize_type === 'credit' && (
                                            <li>
                                                <h4>Prize Value</h4>
                                                <h6>
                                                    {prizeDetails.prize_value?.from_value === prizeDetails.prize_value?.to_value
                                                        ? prizeDetails.prize_value?.from_value
                                                        : `${prizeDetails.prize_value?.from_value} - ${prizeDetails.prize_value?.to_value}`}
                                                </h6>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="slider-prize-details">
                                    {prizeDetails.image ? (
                                        <div className="slider-product">
                                            <ImageWithBasePath src={prizeDetails.image} alt="Prize image" />
                                            <h4>{prizeDetails.name}</h4>
                                        </div>
                                    ) : (
                                        <p>No image available</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="btn-addprize mb-4">
                            <button
                                type="button"
                                className="btn btn-cancel me-2"
                                onClick={() => {
                                navigate(route.prizeList);
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrizeDetail;
